const actions = {
    YOUNOTE_ADMIN_DASHBOARD_START: 'YOUNOTE_ADMIN_DASHBOARD_START',
    YOUNOTE_ADMIN_DASHBOARD_SUCCESS: 'YOUNOTE_ADMIN_DASHBOARD_SUCCESS',
    YOUNOTE_ADMIN_DASHBOARD_FAILURE: 'YOUNOTE_ADMIN_DASHBOARD_FAILURE',
};

export default actions;